function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { connect } from 'react-redux';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
const PopupManagerContainer = props => {
  const {
    popupManager: {
      shownPopup,
      params
    },
    onClose,
    popupsDictionary
  } = props;
  const RenderPopup = popupsDictionary[shownPopup];
  return RenderPopup ? /*#__PURE__*/React.createElement(RenderPopup, _extends({
    onClose: onClose
  }, params)) : null;
};
const mapStateToProps = state => ({
  popupManager: state.popupManager
});
const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(hidePopup());
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(PopupManagerContainer);